import React from "react";
import CountDownTimer from "../commonComponent/CountDownTimer";
export default function PayTimer(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "paytimer-section" },
            React.createElement("div", null, "Approve the payment within"),
            React.createElement("div", null,
                React.createElement(CountDownTimer, { duration: props.duration, onTimerUpdate: props.checkStatus })),
            React.createElement("div", { className: "mgt-10" }, "minutes"),
            React.createElement("div", { className: "mt-3" }, "You will be redirected to status page, once a response is received from the service provider"))));
}
